<template>
  <div class="usage-terms-personalize-form-preview-login"
       :style="{background: bg}">
    <div class="container">
      <i class="usage-terms-personalize-form-preview-login-back mdi mdi-arrow-left pointer"></i>

      <div class="usage-terms-personalize-form-preview-login-header">
        <img :src="logoRef" />
      </div>

      <div class="usage-terms-personalize-form-preview-login-input">
        <label class="usage-terms-personalize-form-preview-login-input-label"
               :style="{ color: textColor }"
               for="signupEmailInput">{{$t('message.generics.message.email')}}l</label>
        <input class="usage-terms-personalize-form-preview-login-input-inpt" />
      </div>

      <div class="usage-terms-personalize-form-preview-login-input">
        <label class="usage-terms-personalize-form-preview-login-input-label"
               :style="{ color: textColor }"
               for="signupEmailInput">{{$t('message.loginPersonalize.message.fullName')}}</label>
        <input class="usage-terms-personalize-form-preview-login-input-inpt" />
      </div>

      <div class="usage-terms-personalize-form-preview-login-input">
        <label class="usage-terms-personalize-form-preview-login-input-label"
               :style="{ color: textColor }"
               for="signupEmailInput">{{$t('message.loginPersonalize.message.dateOfBirth')}}</label>
        <input class="usage-terms-personalize-form-preview-login-input-inpt" />
      </div>

      <div class="usage-terms-personalize-form-preview-login-input">
        <label class="usage-terms-personalize-form-preview-login-input-label"
               :style="{ color: textColor }"
               for="signupEmailInput">{{$t('message.generics.message.phoneNumber')}}</label>
        <input class="usage-terms-personalize-form-preview-login-input-inpt" />
      </div>

      <div class="usage-terms-personalize-form-preview-login-input usage-terms-personalizer-form-preview-login-radios">
        <p class="usage-terms-personalizer-form-preview-login-radios-label"
           :style="{ color: textColor }">{{$t('message.statistics.message.gender')}}</p>

        <div class="usage-terms-personalizer-form-preview-login-radios-list">
          <div class="usage-terms-personalizer-form-preview-login-radios-list-item">
            <div class="usage-terms-personalizer-form-preview-login-radios-list-item-inpt"
                 :style="{ borderColor: textColor }"></div>
            <div class="usage-terms-personalizer-form-preview-login-radios-list-item-text"
                 :style="{ color: textColor }">{{$t('message.statistics.message.female')}}</div>
          </div>
          <div class="usage-terms-personalizer-form-preview-login-radios-list-item">
            <div class="usage-terms-personalizer-form-preview-login-radios-list-item-inpt"
                 :style="{ borderColor: textColor }"></div>
            <div class="usage-terms-personalizer-form-preview-login-radios-list-item-text"
                 :style="{ color: textColor }">{{$t('message.statistics.message.male')}}</div>
          </div>
          <div class="usage-terms-personalizer-form-preview-login-radios-list-item">
            <div class="usage-terms-personalizer-form-preview-login-radios-list-item-inpt"
                 :style="{ borderColor: textColor }"></div>
            <div class="usage-terms-personalizer-form-preview-login-radios-list-item-text"
                 :style="{ color: textColor }">{{$t('message.loginPersonalize.message.doNotInform')}}</div>
          </div>
        </div>

      </div>

      <button class="btn usage-terms-personalize-form-preview-login-action"
              :style="buttonStyle">
        {{$t('message.generics.message.register')}}
      </button>

    </div>
  </div>
</template>

<script>
export default {
  components: {},

  props: {
    config: {
      type: Object,
    },
    temporaryImage: {
      type: String
    },
    temporaryLogo: {
      type: String
    }
  },

  data() {
    return {
      
    };
  },

  watch: {
    config: {
      deep: true,
      handler(newConfig, oldConfig) {

        if(newConfig.registerBackground) {
          if( newConfig.registerBackground !== oldConfig.registerBackground)          
           this.bg = {background: `url(${process.env.VUE_APP_BACK_END_URL}/file/public/background/${this.config.registerBackground}?rnd=${this.cacheKey})`}          
        } else {
          this.bg = {background: newConfig.registerStyle.bg}
        }
      },
    },
  },

  computed: {    
    textColor() {
      return this.config.registerStyle.text;
    },    
    logoRef() {
      return this.temporaryLogo ?
             this.temporaryLogo:
             this.config.logo ? this.config.logo : 
             this.config.isDefaultGreen ? "/images/logo.png" : "/images/logo-white.png"
    },
    buttonStyle() {
      return {
        color: this.config.registerStyle.button.color,
        background: this.config.registerStyle.button.bg,
      };
    },
    bg: {
      get() {
        return this.temporaryImage ? `url(${this.temporaryImage})` :
              this.config.registerBackground ?
             `url(${process.env.VUE_APP_BACK_END_URL}/file/public/background/${this.config.registerBackground}?rnd=${this.cacheKey})` :             
             this.config.registerStyle.bg
      },
      set() {
        return
      }
    }
  },

  methods: {},

  mounted() {},

  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.usage-terms-personalize-form-preview-login {
  width: 300px;
  height: 500px;
  border: 1px solid black;
  border-radius: 25px;
  background: linear-gradient(0deg, #092f39, #497461);
  position: relative;
  background-size: cover !important;
  background-position: center !important;

  .container {
    height: 100%;
    display: flex;
    flex-direction: column;

    .usage-terms-personalize-form-preview-login-back {
      position: absolute;
      color: white;
    }

    .usage-terms-personalize-form-preview-login-header {
      margin-bottom: 50px;

      img {
        display: block;
        margin: 0 auto;
        max-height: 75px;
        max-width: 100%;
      }
    }

    .usage-terms-personalize-form-preview-login-input {
      margin-bottom: 20px;
      position: relative;

      .usage-terms-personalize-form-preview-login-input-label {
        font-size: 12px;
        margin: 0;
        position: absolute;
        color: white;
      }

      .usage-terms-personalize-form-preview-login-input-inpt {
        border-radius: 0;
        height: 24px;
        padding: 0;
        background: transparent;
        border: none;
        border-bottom: 1px solid #828282;
        font-weight: 600;
        color: white;
        transition: all 0.5s;
        width: 100%;

        &:focus {
          box-shadow: none !important;
          outline: none;
        }
      }
    }

    .usage-terms-personalizer-form-preview-login-radios {
      .usage-terms-personalizer-form-preview-login-radios-label {
        font-size: 12px;
        margin: 0;
        color: white;
        margin-bottom: 5px;
      }

      .usage-terms-personalizer-form-preview-login-radios-list {
        display: flex;
        justify-content: space-between;

        .usage-terms-personalizer-form-preview-login-radios-list-item {
          display: flex;
          align-items: center;

          .usage-terms-personalizer-form-preview-login-radios-list-item-inpt {
            width: 10px;
            height: 10px;
            border: 1px solid white;
            margin-right: 5px;
            border-radius: 50%;
          }

          .usage-terms-personalizer-form-preview-login-radios-list-item-text {
            font-size: 10px;
            color: white;
          }
        }
      }
    }

    .usage-terms-personalize-form-preview-login-action {
      margin: 0 auto;
      width: fit-content;
      background: white;
      text-align: center;
      border-radius: 24px;
      font-size: 9px;
      position: relative;
      text-transform: uppercase;
      padding-right: 40px;
      padding-left: 40px;
    }
  }
}
</style>
